// Next Imports
import Link from "next/link";

// MUI Imports
import { Grid2 as Grid, Box, Typography } from "@mui/material";

// Components Imports
import CategoryCard from "./CategoryCard";

const CategoryComponent = ({ technologyWithArticles }) => {
  const {
    technology: { name, slug },
    articles,
  } = technologyWithArticles;

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "30px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                borderLeft: "3px solid rgb(226, 232, 240)",
                borderRight: "3px solid rgb(226, 232, 240)",
                width: "0px",
                height: { xs: "25px", sm: "35px" },
                borderRadius: "50px",
                marginRight: { xs: "10px", sm: "30px" },
              }}
            />
            <Typography
              component="h2"
              variant="h5"
              sx={{
                fontSize: { xs: "20px", sm: "28px", lg: "34px" },
                fontWeight: 900,
                color: "#2D3748",
                marginRight: "8px",
              }}
            >
              {name}
            </Typography>
          </Box>
          <Box
            component={Link}
            href={`/blog/${slug}`}
            sx={{
              backgroundColor: "#EDF2F7",
              padding: { xs: "5px 10px", sm: "5px 15px" },
              borderRadius: "5px",
              width: "80px",
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
              color: "#7F8DA1",
              textDecoration: "none",
              "&:hover": {
                color: "#ffffff",
                backgroundColor: "#718096",
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: { xs: 600 },
                fontSize: { xs: "10px", sm: "12px" },
              }}
            >
              View More
            </Typography>
          </Box>
        </Box>
      </Grid>

      {articles.map((article) => (
        <Grid size={{ xs: 12, md: 6 }} key={article.id}>
          <CategoryCard
            slug={article.slug}
            topic={article.topic.name}
            topicSlug={article.topic.slug}
            articleImage={
              article.articleImageUrl ?? "/software_development_fallback.webp"
            }
            title={article.name}
            author={article.author}
            date={article.createdAt}
            headingLevel="h3"
          />
        </Grid>
      ))}
    </>
  );
};

export default CategoryComponent;
